import { Parser } from "@siteimprove/alfa-parser";
import { Refinement } from "@siteimprove/alfa-refinement";
import { Compound, Simple } from "../../../selector/index.js";
import { After } from "./after.js";
import { Backdrop } from "./backdrop.js";
import { Before } from "./before.js";
import { Cue } from "./cue.js";
import { CueRegion } from "./cue-region.js";
import { FileSelectorButton } from "./file-selector-button.js";
import { FirstLetter } from "./first-letter.js";
import { FirstLine } from "./first-line.js";
import { GrammarError } from "./grammar-error.js";
import { Marker } from "./marker.js";
import { Part } from "./part.js";
import { Placeholder } from "./placeholder.js";
import { Selection } from "./selection.js";
import { Slotted } from "./slotted.js";
import { SpellingError } from "./spelling-error.js";
import { TargetText } from "./target-text.js";
import { PseudoElementSelector } from "./pseudo-element.js";
const { either, filter } = Parser;
const { or } = Refinement;
/**
 * @public
 */
export var PseudoElement;
(function (PseudoElement) {
    function isPseudoElement(value) {
        // Note: this is not totally true as we could extend PseudoElementSelector
        // without making it a PseudoElement. We're likely having other problems in
        // that case…
        return value instanceof PseudoElementSelector;
    }
    PseudoElement.isPseudoElement = isPseudoElement;
    function parse(parseSelector) {
        return either(After.parse, Before.parse, Cue.parse(parseSelector), CueRegion.parse(parseSelector), FirstLetter.parse, FirstLine.parse, Backdrop.parse, FileSelectorButton.parse, GrammarError.parse, Marker.parse, Part.parse, Placeholder.parse, Selection.parse, Slotted.parse(() => filter(parseSelector(), or(Compound.isCompound, Simple.isSimple), () => "::slotted() only accepts compound selectors")), SpellingError.parse, TargetText.parse);
    }
    PseudoElement.parse = parse;
})(PseudoElement || (PseudoElement = {}));
//# sourceMappingURL=index.js.map